import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Card from '../elements/Card';
import Title from './Title';

// A small "learn more about this event" card for public (anonymous) pages — the
// team vote form, the cheer-confirmation page. Event-driven: the kicker/title use
// the event's own name (not hard-coded to Hercules Trophy). It prefers the event's
// own commercial site (commercialUrl) so the CTA sends people to the event's brand,
// not to tornea; failing that it uses the referralLink (the event's shop, tagged
// with the cheered team — Phase-1 referral loop); otherwise it links to the event's
// on-platform public page. Renders nothing when there's nothing to point at.
// `flush` drops the Card's own side margins, for the auth shell (invite pages),
// where it sits under .auth__card and has to line up with it exactly.
const EventCta = ({ eventName, eventId, referralLink, commercialUrl, flush = false }) => {
  const { t } = useTranslation('common');
  const external = commercialUrl || referralLink;
  const href = external || (eventId ? `/public-event/${eventId}` : null);
  if (!eventName || !href) return null;

  const label = t('learnMoreAboutEvent', { event: eventName });
  // external is a full URL (the commercial site, or the shop that picks up
  // ?ref_team on load) — a plain anchor; the public-page fallback stays a
  // client-side Link.
  // The heading already spells the event out, so the button stays a short "Learn more".
  const cta = external
    ? <a href={href} className="public-cta-link">{t('learnMore')}</a>
    : <Link to={href} className="public-cta-link">{t('learnMore')}</Link>;

  return (
    <Card p="3" mx={flush ? '0' : '3'} className="public-info-card">
      <div className="public-kicker mb-2">{eventName}</div>
      <Title heading="4" my="0" align="start" className="public-cta-title mb-2">{label}</Title>
      <p className="text-secondary mb-3">{t('eventCtaBlurb', { event: eventName })}</p>
      {cta}
    </Card>
  );
};

export default EventCta;
